<template>
    <div class="topic-data-container">
        <div class="text-right topic-btn-container">
            <div>
                <button
                    v-if="checkAuthorization('setting-role_create')"
                    class="create-topic-btn"
                    @click="showModalCreate"
                >
                    THÊM TOPIC 
                    <v-icon>mdi-plus</v-icon>
                </button>
            </div>
        </div>

        <v-row>
            <v-col cols="6" class="px-11" v-for="(topic, index) in topics" :key="index">
                <div class="topic-wrapper">
                    <div class="topic-header">
                        <span class="topic-name">
                            {{ topic.name }}
                        </span>
                        <div class="topic-actions">
                            <span
                                v-if="checkAuthorization('setting-role_create')"
                                class="topic-action"
                                @click="createNewRole(topic)"
                            >
                                Thêm nhóm quyền
                            </span>
                          <span
                              v-if="checkAuthorization('setting-role_create')
                                && checkAuthorization('setting-role_update')"
                          > | </span>
                            <span
                                v-if="checkAuthorization('setting-role_update')"
                                class="topic-action"
                                @click="showModalDetail(topic)"
                            >
                                Sửa
                            </span>
                            <span
                                v-if="checkAuthorization('setting-role_delete')
                                  && checkAuthorization('setting-role_update')"
                            > | </span>
                            <span
                                v-if="checkAuthorization('setting-role_delete')"
                                class="topic-action"
                                @click="deleteTopic(topic)"
                            >
                                Xóa
                            </span>
                        </div>
                    </div>
                    <div class="topic-roles" v-if="topic.roles.length > 2">
                        <div class="role-data" v-for="(role, indexRole) in topic.roles.slice(0, 2)" :key="indexRole">
                            <v-icon>mdi-account-outline</v-icon> 
                            <div class="role-name">
                                {{ role.name }}
                            </div>
                            <div class="role-actions">
                                <span
                                    v-if="checkAuthorization('setting-role_update')"
                                    class="role-action"
                                    @click="detailRole(role)"
                                >
                                    Sửa
                                </span>
                                <span
                                    v-if="checkAuthorization('setting-role_update')
                                        && checkAuthorization('setting-role_delete')"
                                > | </span>
                                <span
                                    v-if="checkAuthorization('setting-role_delete')"
                                    class="role-action"
                                    @click="deleteRole(role)"
                                >
                                    Xóa
                                </span>
                            </div>
                        </div>
                        <div class="show-all-roles" @click="showAllRole(topic)">
                            Xem thêm
                        </div>
                    </div>
                    <div class="topic-roles" v-else-if="topic.roles.length == 0">
                        <div class="role-data no-data">
                            Không tìm thấy kết quả
                        </div>
                    </div>
                    <div class="topic-roles" v-else>
                        <div class="role-data" v-for="(role, indexRole) in topic.roles" :key="indexRole">
                            <v-icon>mdi-account-outline</v-icon>
                            <div class="role-name">
                                {{ role.name }}
                            </div>
                            <div class="role-actions">
                                <span
                                    v-if="checkAuthorization('setting-role_update')"
                                    class="role-action"
                                    @click="detailRole(role)"
                                >
                                    Sửa
                                </span>
                                <span
                                    v-if="checkAuthorization('setting-role_update')
                                      && checkAuthorization('setting-role_delete')"
                                > | </span>
                                <span
                                    v-if="checkAuthorization('setting-role_delete')"
                                    class="role-action"
                                    @click="deleteRole(role)"
                                >
                                    Xóa
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-row>

        <topic-role 
            :showRole="showRole"
            :topic="topic"
        />

        <topic-form 
            :showCreate="showCreate"
            :isCreate="isCreate"
            :topic="topic"
            :list="list"
            :allowCreateTopic="allowCreateTopic"
        />
    </div>
</template>

<script>
import moment from 'moment'
import TopicRole from './TopicRole'
import TopicForm from './TopicForm'
import RepositoryFactory from '@/repositories/RepositoryFactory'
const RoleRepository = RepositoryFactory.get('role')
export default {
    components: {
        TopicRole,
        TopicForm
    },
    props: {
        topics: {
            type: Array,
            default: () => {[]}
        }
    },
    data() {
        return {
            showCreate: false,
            isCreate: true,
            showRole: false,
            allowCreateTopic: true,
            topic: {},
            list: [
                {
                    name: '',
                    error: '',
                    id: moment().format('YYYYMMDDHHmmss')
                }
            ]
        }
    },

    created() {
        Bus.$on('show-detail-topic-modal', topic => {
            this.showModalDetail(topic)
        })

        Bus.$on('delete-topic', topic => {
            this.deleteTopic(topic)
        })

        Bus.$on('delete-topic-role', role => {
            this.deleteRole(role)
        })

        Bus.$on('close-topic-role-modal', () => {
            this.showRole = false
        })

        Bus.$on('close-create-topic-modal', () => {
            this.list = [
                {
                    name: '',
                    id: moment().unix()
                }
            ]
            this.showCreate = false
        })

        Bus.$on('save-topic-role', data => {
            this.saveTopic(data)
        })

        Bus.$on('action-create-topic', () => {
            this.allowCreateTopic = false
        })
    },

    beforeDestroy() {
        Bus.$off('show-detail-topic-modal')
        Bus.$off('delete-topic')
        Bus.$off('delete-topic-role')
        Bus.$off('close-topic-role-modal')
        Bus.$off('close-create-topic-modal')
        Bus.$off('save-topic-role')
        Bus.$off('action-create-topic')
    },
    
    methods: {
        showAllRole(topic) {
            this.topic = topic
            this.showRole = true
        },

        showModalCreate() {
            this.isCreate = true
            this.showCreate = true
        },

        showModalDetail(topic) {
            this.topic = _.cloneDeep(topic)
            this.isCreate = false
            this.showCreate = true
        },

        async saveTopic(data) {
            if (this.isCreate) {
                let res = await RoleRepository.createTopic({ name: data.map(i => i.name.trim()) })

                if (res.success) {
                    this.showCreate = false
                    this.allowCreateTopic = true
                    this.list = [
                        {
                            name: '',
                            error: '',
                            id: moment().format('YYYYMMDDHHmmss')
                        }
                    ]
                    this.$swal({
                        title: 'Cập nhật dữ liệu thành công',
                        timer: 1000
                    })
                    Bus.$emit('search-topic-list')
                } else {
                    this.allowCreateTopic = true
                    this.$swal({
                        title: 'Lỗi!',
                        text: _.get(res, 'message', '')
                    })
                }
            } else {
                let res = await RoleRepository.updateTopic(data.id, {
                    ...data,
                    name: data.name.trim()
                })

                if (res.success) {
                    this.showCreate = false
                    this.allowCreateTopic = true
                    this.$swal({
                        title: 'Cập nhật dữ liệu thành công',
                        timer: 1000
                    })
                    Bus.$emit('search-topic-list')
                } else {
                    this.allowCreateTopic = true
                    this.$swal({
                        title: 'Lỗi!',
                        text: _.get(res, 'message', '')
                    })
                }
            }
        },

        async deleteTopic(topic) {
            this.$swal({
                title: 'Bạn có chắc muốn xóa topic này?',
                showCancelButton: true,
                cancelButtonText: 'Bỏ qua'
            }).then(async response => {
                if (response.value) {
                    const res = await RoleRepository.deleteTopic(topic.id)

                    if (res.success) {
                        this.$swal({
                            title: 'Cập nhật dữ liệu thành công',
                            timer: 1000
                        })
                        Bus.$emit('search-topic-list')
                    } else {
                        this.$swal({
                            title: 'Lỗi!',
                            text: _.get(res, 'message', '')
                        })
                    }
                }
            })
        },

        createNewRole(topic) {
            this.$router.push({
                path: '/setting/create-role',
                query: {
                    topicId: topic.id
                }
            })
        },

        detailRole(role) {
            this.$router.push({
                name: 'EditRole',
                params: {
                    id: role.id
                }
            })
        },

        async deleteRole(role) {
            this.$swal({
                title: 'Bạn có chắc muốn xóa nhóm quyền này?',
                showCancelButton: true,
                cancelButtonText: 'Bỏ qua'
            }).then(async response => {
                if (response.value) {
                    const res = await RoleRepository.delete(role.id)

                    if (res.success) {
                        this.$swal({
                            title: 'Cập nhật dữ liệu thành công',
                            timer: 1000
                        })
                        Bus.$emit('search-topic-list')
                    } else {
                        this.$swal({
                            title: 'Lỗi!',
                            text: _.get(res, 'message', '')
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped>
.topic-btn-container {
    padding: 10px 32px 20px;
}

.topic-data-container {
    padding-top: 10px;
}

.create-topic-btn {
    padding: 5px 8px;
    border: 1px solid black;
    font-size: 14px;
    font-weight: 400;
    border-radius: 8px;
}

.create-topic-btn i {
    color: black;
}

.topic-wrapper {
    background-color: white;
    border: 1px inner black;
    border-radius: 15px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    height: 100%;
}

.topic-header {
    width: 100%;
    padding: 15px 20px 15px 30px;
    background-color: #F3F2F9;
    border-radius: 15px 15px 0px 0px;
}

.topic-name {
    font-size: 20px;
    font-weight: 600;
}

.topic-actions {
    display: none;
    font-size: 14px;
    color: #2D9CDB;
    float: right;
    padding-top: 4px;
    font-weight: 300;
}

.topic-action {
    cursor: pointer;
}

.topic-action:hover {
    text-decoration: underline;
    text-underline-position: below;
}

.topic-wrapper:hover .topic-actions {
    display: block;
}

.topic-roles {
    padding: 15px 20px 15px 30px;
}

.role-data {
    display: flex;
    padding: 10px 0px;
}

.role-data i {
    font-size: 24px;
}

.role-name {
    font-size: 16px;
    padding: 4px 0px 0px 10px;
}

.role-data:hover .role-name {
    font-weight: 600;
}

.role-data.no-data {
    color: red;
}

.role-actions {
    display: none;
    font-size: 12px;
    color: #2D9CDB;
    padding: 8px 0px 0px 10px;
    font-weight: 300;
}

.role-action {
    cursor: pointer;
}

.role-action:hover {
    text-decoration: underline;
    text-underline-position: below;
}

.role-data:hover .role-actions {
    display: block;
}

.show-all-roles {
    text-align: right;
    font-style: italic;
    cursor: pointer;
}

.show-all-roles:hover {
    text-decoration: underline;
    text-underline-position: below;
}
</style>
